/**
 * taskEntity - Tradução entre a entidade-raiz do processo e o tipo de tarefa
 *
 * Retenção e Jurídico reaproveitam a estrutura de Tarefas no banco (tabela
 * `tasks` + coluna `task_type`), mas são módulos SEPARADOS: um processo de
 * Tarefa não pode oferecer categorias, fases, classificações ou motivos de
 * Retenção/Jurídico (e vice-versa).
 *
 * Este utilitário centraliza essa tradução para que todos os pontos do
 * construtor (parâmetros de ação, filtros do gatilho, condições) filtrem pelo
 * mesmo critério.
 *
 * @version 1.0.0
 * RELEASE: 2026-09-13 v1.0.0 - Criação inicial (separação dos três módulos)
 */

import type { TaskModuleType } from '@/hooks/useTaskModuleType';

/** Mapa entidade-raiz do processo -> tipo de tarefa */
const ENTIDADE_PARA_TIPO: Record<string, TaskModuleType> = {
  task: 'normal',
  retention: 'retention',
  legal: 'legal',
};

/**
 * Retorna o tipo de tarefa da entidade-raiz, ou `null` quando o processo não é
 * de um módulo de tarefas (Negócio, Financeiro...). Nesse caso o comportamento
 * anterior é preservado (listas completas).
 */
export function taskTypeDaEntidade(entidade?: string | null): TaskModuleType | null {
  if (!entidade) return null;
  return ENTIDADE_PARA_TIPO[entidade] ?? null;
}

/** Normaliza o código de módulo do catálogo (`tasks` é sinônimo de `task`). */
export function normalizarModulo(modulo?: string | null): string {
  const bruto = String(modulo || '').toLowerCase();
  return bruto === 'tasks' ? 'task' : bruto;
}
